import { createRoute } from '@tanstack/react-router';
import { pharmacyParentRoute } from 'pages/pharmacy/pharmacyParentRoute';
import { pageResetMiddleWare, zodPage } from 'routes/routeUtils';
import { z } from 'zod';

export const pharmacyLabsRoute = createRoute({
  getParentRoute: () => pharmacyParentRoute,
  path: '/labs',
  validateSearch: z.object({
    search: z.string().optional(),
    page: zodPage,
    onlyPartners: z.boolean().default(true),
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() => import('pages/pharmacy/Labs/PharmacyLabsPage/PharmacyLabsPage').then((d) => d.Route));
